import React, { memo } from 'react';
import CheckBoxAsToggle from '@lib/components/CheckBoxAsToggle/CheckBoxAsToggle';
import { CheckboxSizes } from '@lib/components/CheckBox/enums';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';

export type ToggleHeaderCellProps = {
  id?: string;
  checked: boolean;
  disabled: boolean;
  onChange: (next: boolean) => void;
  label: string;
  tooltipBody?: string;
};

function ToggleHeaderCell({
  id = 'toggle-header',
  checked,
  disabled,
  onChange,
  label,
  tooltipBody,
}: ToggleHeaderCellProps) {
  return (
    <div>
      <CheckBoxAsToggle
        id={id}
        name={id}
        size={CheckboxSizes.Small}
        checked={checked}
        disabled={disabled}
        onChange={() => onChange(!checked)}
        label={label}
        labelTypographyProps={{ variant: 'caption', strong: true }}
        rightLabelIcon={
          tooltipBody ? (
            <MaterialIcon icon="info" size="md-16" symbolsOutlined />
          ) : undefined
        }
        rightLabelIconTooltipProps={
          tooltipBody ? { body: tooltipBody } : undefined
        }
      />
    </div>
  );
}

export default memo(ToggleHeaderCell);
